import { LanguageSwitcherContainer } from '~/app/components/LanguageSwitcher';

export function LoginToolbar() {
  return (
    <div
      style={{
        position: 'absolute',
        top: '20px',
        right: '20px',
        zIndex: 1000,
      }}
    >
      <LanguageSwitcherContainer />
    </div>
  );
}
